import React from "react";
import Header from "../header2/Header";
import { motion } from "framer-motion";
import Slider from "react-slick";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import CustomerContext from "../blog-folder/CustomerContext";
import Seo from "../seo/Seo";
import Power from "./Power";

const About = () => {
  const { handleOpen } = React.useContext(CustomerContext);
  const settings3 = {
    infinite: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    cssEase: "linear",
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings7 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 4,
    speed: 500,
    nextArrow: <SampleNextArrow2 />,
    prevArrow: <SamplePrevArrow2 />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // Slider section start-----------------------------------------
  function SampleNextArrow2(props) {
    const { onClick } = props;
    return (
      <div className="slider-custome-button-next2" onClick={onClick}>
        <ArrowForwardIosIcon className="forword-arrow2" />
      </div>
    );
  }

  function SamplePrevArrow2(props) {
    const { onClick } = props;
    return (
      <div className="slider-custome-button-prev2" onClick={onClick}>
        <ArrowBackIosIcon className="backword-arrow2" />
      </div>
    );
  }

  const schema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "G-Rank",
        item: "https://www.grank.co.in/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "About",
        item: "https://www.grank.co.in/about",
      },
    ],
  };

  return (
    <>
      <Seo
        title="Best Digital Marketing Services In Hyderabad, Bangalore | G-Rank"
        description="Grow with G-Rank’s digital marketing services in Hyderabad and Bangalore, including SEO, PPC, social media marketing, and web development. Generate leads and boost sales!"
        name="G-Rank"
        type="website"
        YahooSeeker="INDEX, FOLLOW"
        msnbot="INDEX, FOLLOW"
        googlebot="INDEX, FOLLOW"
        keywords="Best Digital Marketing Services In Hyderabad, Best Digital Marketing Services In Bangalore, Best Digital Marketing Services In India."
        searchengines="ALL"
        canonical="https://www.grank.co.in/about"
        schema={schema}
      ></Seo>

      <section className="section-top">
        <Header />
        {/* banner start */}
        <div className="organic-marketing-banner">
          <img
            className="img-fluid w-100 mobile-none"
            src="assest/photos/organicmarketing/organic-marketing-seo-banner.png"
            alt="G-Rank"
            title="organic marketing"
          />
          <img
            className="img-fluid w-100 desktop-none"
            src="assest/photos/organicmarketing/organic-marketing-seo-banner-mobile2.png"
            alt="G-Rank"
            title="organic marketing"
          />
          <div className="organic-marketing-banner-new-div">
            <motion.img
              className="img-fluid w-100"
              src="assest/photos/organicmarketing/organic-yellow-patch2.png"
              alt="G-Rank"
              title="grank"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
            />
            <h1 data-text="SearchEngine Optimization">About Us</h1>
            {/*<h2>Industries We Serve</h2>*/}

            {/*<h3 onClick={handleOpen}>
              <NavLink to="">Explore</NavLink>
            </h3>*/}
            <Breadcrumbs
              className="org-breadcru  breadcrumbs"
              aria-label="breadcrumb"
            >
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#000" : "#000",
                })}
                to="/"
              >
                <p>Home</p>
              </NavLink>
              <Typography color="#000">About</Typography>
            </Breadcrumbs>
          </div>
        </div>
        {/* banner end */}

        {/* seo service start */}
        <section className="organic-market-sem-service-section inds-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="org-mark-sem-text abtxt">
                  <motion.h4
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                  >
                    About Us
                  </motion.h4>
                </div>
              </div>

              <motion.div
                className="col-12 col-md-12 col-lg-12"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2 }}
              >
                <p className="abt-txt">
                  G-Rank - Digital Marketing Partner an ISO 9001:2008 certified
                  company, established in 2010, is leading Digital Marketing
                  company. We strategize and deliver pertinent digital marketing
                  campaigns that adds value to the client`s bottom line. We are
                  a proud holder of Google Certified Partnership since 2011.
                  Ever since its inception, G-Rank has always focused on
                  building an ecosystem to offer end to end digital marketing
                  solutions to clients across the India. From 5 clients in 2010
                  to 180+ clients in 2026, G-Rank`s commitment for growth is a
                  true testimony of delivering top-notch digital campaigns
                  fueled by innovation and creativity & performance.
                </p>
                <p className="abt-txt">
                  G-Rank prides itself as a result-oriented digital marketing
                  agency. We specialize in (Google Ads) paid marketing, search
                  engine optimization (SEO), social media marketing & marketing
                  automation solutions. We help our clients to harness the right
                  digital marketing strategy to amplify their brand awareness
                  and lead generation. Our cutting-edge digital strategists dive
                  deep to gain deeper understanding of our client's brand,
                  industry and competition. Our strategic, data-driven and
                  creative approach towards digital marketing has enabled us to
                  deliver 100% results every time.
                </p>
              </motion.div>
            </div>
            <div className="row mt50">
              <div className="col-12">
                <div className="org-mark-sem-text abtxt">
                  <motion.h4
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                  >
                    Our Vision
                  </motion.h4>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <motion.div
                  className="col-12 col-md-12 col-lg-12"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  <p className="ovm-txt">
                    As a leading digital marketing company, we cater to myriad
                    digital marketing services that can augment business and
                    open up potential opportunities for tapping maximum leads.
                    Further, to ensure that the digital marketing solutions are
                    potential enough to take care of all anticipatory challenges
                    that clients face in the course of their business. We look
                    at our client relationships as long-term investments based
                    on trust, timely delivery, and the best results. Thus, we
                    intend to create a conducive and mutually beneficial
                    environment where our clients can grow and expand with us on
                    a global level.
                  </p>
                </motion.div>
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <img
                  className="img-fluid w-100 ovis"
                  src="assest/photos/performance-marketing/smm-key-img.png"
                  alt="G-Rank"
                  title="Our Vision"
                />
              </div>
            </div>

            <div className="row mt50">
              <div className="col-12">
                <div className="org-mark-sem-text abtxt">
                  <motion.h4
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                  >
                    Our Mission
                  </motion.h4>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <img
                  className="img-fluid w-100 ovis"
                  src="assest/photos/performance-marketing/marketingboostsales.png"
                  alt="G-Rank"
                  title="Our Mission"
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <motion.div
                  className="col-12 col-md-12 col-lg-12"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  <p className="ovm-txt">
                    To develop cost-effective and innovative digital marketing
                    solutions for various industries by leveraging cutting-edge
                    strategies and industry’s best practices that guarantee high
                    ROI and growth. In this process, we intend to help our
                    clients meet their digital marketing goals and improve their
                    brand visibility. We aspire to go bigger globally as the
                    best Digital Marketing Company.
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
        </section>
        {/* seo service end */}

        {/* action yellow start*/}
        <div className="action-yellow-div-text">
          <motion.p
            initial={{ opacity: 0, scale: 0, y: 100 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Want to Elevate Your Brand?
            <br /> Get in Touch with Us Today
          </motion.p>
          <NavLink to="">
            <motion.p
              className="action-yellow-div-buttom"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              onClick={handleOpen}
            >
              Contact Us <ArrowRightAltIcon />
            </motion.p>
          </NavLink>
        </div>
        {/* action yellow end*/}

        {/* Quick Link section start */}
        <section>
          <div className="container-fluid">
            <div>
              <motion.h2
                className="branding-quick-link"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6 }}
              >
                Quick Links
                <p className="d-block"> For You</p>
              </motion.h2>
              <Slider {...settings3}>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/branding-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Branding</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/creative-content-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Creative & <p className="d-block"> Content</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/organic-marketing-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Organic <p className="d-block"> marketing</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/performance-marketing-company"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Performance <p className="d-block"> marketing</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/social-media-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Social Media</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/web-development-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Web <p className="d-block"> Development</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/domain"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Domain</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/hosting-service"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Web <p className="d-block"> Hosting</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/web-security-services"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Security</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/email-hosting-provider"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Email</h4>
                  </div>
                </NavLink>
              </Slider>
            </div>
          </div>
        </section>
        {/* Quick Link section end */}
        <img
          className="img-fluid w-100"
          src="assest/photos/branding/branding-footer-img.png"
          alt="G-Rank"
          title="organic marketing"
        />
      </section>
    </>
  );
};

export default About;
